import React, { useEffect, useState } from "react";
import { Edit } from "lucide-react";
import useApiHook from "../../../../utils/useApi";
import { PermApiResponse } from "../../../../interface/interfaces";
import EditRoleModal from "../../../../components/modals/EditRoleModal";

const EditRoleButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [permissions, setPermissions] = useState<string[]>([]);

  const { data, makeRequest } = useApiHook<PermApiResponse>(
    "/admin/system-role",
    {
      method: "get",
    }
  );

  useEffect(() => {
    makeRequest();
  }, []);

  useEffect(() => {
    if (data && data.data && data.data.rolePermissions) {
      setPermissions(data.data.rolePermissions);
    }
  }, [data]);

  const handleEditRole = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        className="flex items-center gap-2 px-4 py-2 text-sm text-blue-600 bg-blue-50 hover:bg-blue-100 rounded border border-blue-200 transition-colors"
        onClick={handleEditRole}
      >
        <Edit size={16} />
        <span>Edit Role</span>
      </button>

      <EditRoleModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        permissions={permissions}
      />
    </>
  );
};

export default EditRoleButton;
